import ILandingDomain from "@/interfaces/ILandingDomain";
import IMultiSelectItem from "@/interfaces/selects/IMultiSelectItem";
import {Component, Prop, Vue, Watch} from 'vue-property-decorator';

import Loader from '@/components/Includes/Loader/Loader.vue';
import LandingDomainForm from '@/components/LandingDomains/LandingDomainForm/LandingDomainForm.vue';
import {Action} from 'vuex-class';

import {addDays, format} from 'date-fns';

const today = new Date();

@Component({
    name: 'LandingDomainDetail',
    components: {
        Loader,
        LandingDomainForm
    }
})

export default class LandingDomainDetail extends Vue {
    @Prop(String) private modalId!: string;
    @Prop(String) private modalTitle!: string;
    @Prop({type: Boolean, default: false}) private hideFooter!: boolean;
    @Prop(Boolean) private showModal!: boolean;
    @Prop(Array) private landingRegions!: IMultiSelectItem[];
    @Prop(Object) private landingDomainData!: ILandingDomain;

    // Begin Vuex Logic for Landing Domain
    @Action private landingDomainRemove!: (id: number) => string;
    @Action private landingDomainExpiresAt!: (payload: { id: number, expiresAt: string }) => string;
    // End Vuex Logic for Landing Domain

    private loading: boolean = true;

    private show: boolean | null = null;

    private initLandingDomainData: ILandingDomain = {
        url: '',
        region: ''
    };

    @Watch('showModal')
    private toggleModal(): void {
        this.show = this.showModal;
    }

    private closeModal() {
        this.initLandingDomainData.url = '';
        this.initLandingDomainData.region = '';
        this.$emit('closeModalLandingDomain')
    }

    private async deleteLandingDomain(time: string) {
        try {
            const expiresAt = time === 'expiresAt' ? time : null;

            const notify = (status: string) => {
                this.closeModal();

                this.$emit('UpdateLandingDomains');

                if (status === 'deleted') {
                    this.$notify({
                        group: 'notice',
                        title: `Domain ${this.landingDomainData.url}`,
                        text: 'Deleted Successfully',
                        type: 'success'
                    });
                } else if (status === 'timer started') {
                    this.$notify({
                        group: 'notice',
                        title: `Domain ${this.landingDomainData.url}`,
                        text: 'Will be deleted in two days',
                        type: 'success'
                    });
                }

            };

            if (expiresAt) {
                const status = await this.landingDomainExpiresAt({
                    id: Number(this.landingDomainData.id),
                    expiresAt: format(addDays(today, 2), "yyyy-MM-dd'T'HH:mm:ss")
                });
                notify(status);
            } else {
                const status = await this.landingDomainRemove(
                    Number(this.landingDomainData.id)
                );
                notify(status);
            }
        } catch (error) {
            throw new Error(error);
        }
    }

    private mounted() {
        this.loading = false;
    }
}